import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchStoreLeadership } from 'queries/store-facts/store-facts'
import { StoreFactsFetchProps } from 'types/api'
import { IResponseStoreLeadership } from 'utils/api'
import { isStore } from 'utils/location'
import { TIME } from 'utils/misc'
import { useAnalytics } from 'utils/analytics'

export function useStoreLeadership({
    env,
    accessToken,
    location,
}: StoreFactsFetchProps): IResponseStoreLeadership {
    const { tenMinutes } = TIME
    const { trackEvent } = useAnalytics()
    const enabled = isStore(location)
    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.STORE_LEADERSHIP, location],
        () =>
            fetchStoreLeadership({
                env,
                accessToken,
                body: {
                    filters: [
                        {
                            type: 'in',
                            pattern: location,
                            dimension: 'store_t_number',
                        },
                    ],
                },
                filters: {
                    card_id: '1320970',
                },
                method: 'POST',
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            enabled,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
